'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InfoPartition = require('../InfoPartition/InfoPartition');

var _InfoPartition2 = _interopRequireDefault(_InfoPartition);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactUsInfo = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ContactUsInfo, _Component);

  function ContactUsInfo() {
    (0, _classCallCheck3.default)(this, ContactUsInfo);
    return (0, _possibleConstructorReturn3.default)(this, (ContactUsInfo.__proto__ || (0, _getPrototypeOf2.default)(ContactUsInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContactUsInfo, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;

      var text = {
        title: t('Contact Us'),
        preKey: 'contact-us_',
        body: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'p',
            null,
            t('CRight is the trading name of Secure Arts Limited.')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('Secure Arts Limited is registered in the UK with registered company number 04868437. UK registered office: 5 Technology Park, Colindeep Lane,'),
            _react2.default.createElement('br', null),
            t('London, NW9 6BX.')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('Email'),
            ': ',
            _react2.default.createElement(
              'a',
              { target: '_blank', href: 'mailto:security@cright.com', rel: 'noopener noreferrer' },
              'security@cright.com'
            )
          )
        ),
        articles: []
      };

      return _react2.default.createElement(_InfoPartition2.default, { text: text });
    }
  }]);
  return ContactUsInfo;
}(_react.Component), _class2.propTypes = {
  t: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = ContactUsInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/ContactUs/ContactUsInfo.js
// module id = 2021
// module chunks = 1